export const MuiCircularProgressTheme = () => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                position: "relative",
                circle: {
                    strokeLinecap: "round",
                },
            },
        },
    };
};
